module.exports = __webpack_public_path__ + "img/pro_two_4.21de9399.jpg";